<template>
  <div class="finish">
        <div class="top">
            <!-- <div class="top_left">
                <div class="icon"></div>
                <div class="game_name">{{storage.appName}}</div>
                <div class="game_name_line">{{$t('title')}}</div>
            </div>
            <div class="top_center">
                <div class="uname">{{storage.roleName}}</div>
                <div class="server_name">({{storage.serverName}})</div>
            </div> -->
            <div class="top_right">
                <!-- <div class="point">
                    <span class="point_num">9910.<em>01</em>礼金</span>
                    <span class="detail"></span>
                </div> -->
                <!-- <div class="user" @click="popCtrl"></div> -->
                <div class="close" @click="pageClose"></div>
                <!-- <div class="pop_down" v-if="popShow">
                    <div class="down_li" @click="dialogCtrl('record')">{{$t('consumeRecord')}}</div>
                </div> -->
            </div>
        </div>
        <div class="over">
            <div>
                <!-- <img src="@/assets/finish.png"> -->
                <!-- <p style="margin-top:5px;color:#fea52d;">{{$t('pending')}}</p> -->
                <p>{{$t('pending')}}</p> 
                <p>{{$t('pendWaiting')}}</p> 
                <el-button class="submit" @click="pageClose" type="danger" size="medium" round>{{$t('backToStore')}}</el-button>
            </div>
            <!-- <div v-if="$route.query.orderStatus == 'error'">
                <p style="margin-top:5px;color:#e60012;">{{$t('payError')}}</p>
                <img src="@/assets/error.png">
                <p>{{$t('payError')}}</p> 
                <p>{{$t('errorAgain')}}</p> 
                <div class="submit" @click="pageClose" style="margin-bottom: 20px;">{{$t('backToGame')}}</div>
                <div class="submit" @click="payHandle">{{$t('payAgain')}}</div>
            </div> -->
        </div>
        <!-- <p>{{$t('backMain', {msg: time})}}</p> -->
  </div>
</template>
 
<script>
import {mapActions, mapGetters} from 'vuex';
import moment from 'moment'
export default {
    name: 'finish',
    data(){
        return {
            storage: {}
        }
    },
    methods:{
        payHandle(){
            this.$router.push({
                path: '/pay',
                // query: {
                //     buyList: JSON.stringify(this.buyList)
                // }
            })
        },
        pageClose(){
            this.$router.push({
                path: '/store',
                query: {
                    from: 'finish'
                }
            })
        },
    },
    computed:{
    },
    mounted() {
        this.storage = JSON.parse(window.localStorage.getItem('storage'))
        this.storage.buyList = ''
        window.localStorage.setItem('storage', JSON.stringify(this.storage))
        // window.vuplex && window.vuplex.postMessage({type: 'close', message: '关闭网页'})
    }
}
</script>
 
<style lang="scss">
.finish{
    position: relative;
    width: 100%;
    height: 100%;
    color: #000;
    .over{
        margin-top: 150px;
        p{
            font-size: 28px;
        }
    }
    .submit{
        // background: url('../assets/submit.png') 0 0 no-repeat;
        // background-size: 285px 66px !important;
        // width: 285px;
        // height: 66px;
        font-size: 22px;
        line-height: 30px;
        // color: #5d371a;
        // position: relative;
        // left: 50%;
        cursor: pointer;
        // margin-left: -142.5px;
        top: 100px;
    }
    .el-input::-webkit-scrollbar-thumb{
        border-radius: 0;
    }
    .el-input__inner{
        border-radius: 0;
    }
    .pop_down_pop{
        z-index: 1;
        background-color: rgba(0,0,0,0);
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
    }
    .close{
        // background: url('../assets/close.png') 0 100% no-repeat;
        background-size: 100% auto !important;
        width: 47px;
        height: 47px;
        position: absolute;
        cursor: pointer;
        left: 330px;
        top: 28px;
    }
    .el-input.is-disabled .el-input__inner{
        background-color: #462f1e;
        color: #fff;
    }
    .el-badge__content{
        top: 40px;
        right: 64px;
    }
    .item_count{
        position: absolute;
        left: 240px;
        top: 145px;
        .el-input-number{
            display: inline-block;
            width: 70px;
        }
        input{
            background-color: #462f1e;
            color: #fff;
            width: 70px;
            height: 26px;
            font-size: 18px;
            line-height: 26px;
            text-align: center;
            border: 0px solid #DCDFE6;
            &:focus-visible {
                outline: -webkit-focus-ring-color auto 0px;
            }
        }
        .cost{
            // background: url('../assets/plus.png') 89% 50% no-repeat;
            background-size: 26px 27px !important;
            display: inline-block;
            width: 26px;
            height: 27px;
            cursor: pointer;
            position: relative;
            top: -2px;
            &.cost_disable{
                filter: grayscale(100%);
                cursor: no-drop;
            }
        }
        .plus{
            // background: url('../assets/plus.png') 89% 50% no-repeat;
            background-size: 26px 27px !important;
            display: inline-block;
            width: 26px;
            height: 27px;
            cursor: pointer;
            position: relative;
            top: -2px;
            &.plus_disable{
                filter: grayscale(100%);
                cursor: no-drop;
            }
        }
    }
    .top{
        height: 90px;
        position: relative;
        display: flex;
        .top_left{
            position: relative;
            width: 300px;
            height: 90px;
            .icon{
                position: absolute;
                width: 57px;
                height: 57px;
                top: 20px;
                left: 30px;
            }
            .game_name{
                font-size: 20px;
                position: absolute;
                left: 90px;
                top: 20px;
            }
            .game_name_line{
                font-size: 28px;
                position: absolute;
                left: 90px;
                top: 45px;
            }
        }
        .top_center{
            position: relative;
            width: 872px;
            height: 90px;
            text-align: left;
            .uname{
                position: relative;
                font-size: 38px;
                line-height: 90px;
                display: inline-block;
            }
            .server_name{
                position: relative;
                font-size: 38px;
                display: inline-block;
                line-height: 90px;
            }
        }
        .top_right{
            position: relative;
            width: 300px;
            height: 90px;
            text-align: left;
            .point_num{
                line-height: 90px;
                font-size: 28px;
                em{
                    font-size: 24px;
                    font-style: initial;
                }
            }
            .detail{
                // background: url('../assets/detail.png') 0 100% no-repeat;
                background-size: 29px 29px !important;
                width: 29px;
                height: 29px;
                position: relative;
                display: inline-block;
                top: 4px;
                left: 4px;
                cursor: pointer;
            }
            .user{
                // background: url('../assets/user.png') 0 100% no-repeat;
                background-size: 47px 47px !important;
                width: 47px;
                height: 47px;
                position: absolute;
                cursor: pointer;
                left: 260px;
                top: 28px;
            }
            .pop_down{
                // background: url('../assets/pop_down.png') 0 100% no-repeat;
                background-size: 288px 339px !important;
                width: 288px;
                height: 339px;
                position: relative;
                left: 115px;
                top: 60px;
                z-index: 9;
                .down_li{
                    position: relative;
                    margin: 0 30px;
                    top: 32px;
                    line-height: 46px;
                    border-bottom: 1px solid #473420;
                    // background: url('../assets/arrow_right.png') 100% 50% no-repeat;
                    background-size: 11px 21px !important;
                    cursor: pointer;
                    &:last-child{
                        border-bottom: 0px solid #473420;
                    }
                }
            }
        }
    }
    .content{
        position: relative;
        height: 793px;
        display: flex;
        .content_left{
            width: 300px;
            height: 73px;
            cursor: pointer;
            margin-top: 5px;
            .tab{
                font-size: 33px;
                line-height: 73px;
                text-align: center;
                font-weight: bolder;
                text-shadow: 1px 1px black;
                // background: url('../assets/tab.png') 85% 50% no-repeat;
                background-size: 20px 20px;
                &.tab_hover{
                    font-size: 33px;
                    line-height: 73px;
                    text-align: center;
                    font-weight: bolder;
                    text-shadow: 1px 1px black;
                    // background: url('../assets/tab_hover.png') 0 100% no-repeat;
                    background-size: 310px 73px;
                }
            }
        }
        .content_center{
            display: flex;
            justify-content: start;
            flex-wrap: wrap;
            align-content: baseline;
            overflow-y: scroll;
            margin-top: 20px;
            margin-bottom: 3px;
            &::-webkit-scrollbar{
                width: 0 !important;
                height: 0 !important;
                display: none;
            }
            .card{
                position: relative;
                width: 384px;
                height: 229px;
                // background: url('../assets/card.png') 89% 50% no-repeat;
                margin: 30px 14px;
                .item_content{
                    display: none;
                }
                .item_limit{
                    display: block;
                }
            }
            .card:hover{
                top: -15px;
                width: 415px;
                height: 288px;
                // background: url('../assets/card_hover.png') 89% 50% no-repeat;
                .item_content{
                    display: block;
                }
                .item_limit{
                    display: none;
                }
            }
            .item_icon{
                background-size: cover;
                width: 153px;
                height: 153px;
                position: absolute;
                left: 38px;
                top: 18px;
            }
            .item_name{
                font-size: 32px;
                line-height: 32px;
                position: absolute;
                left: 210px;
                top: 25px;
                text-align: left;
            }
            .item_point{
                font-size: 20px;
                line-height: 32px;
                position: absolute;
                left: 210px;
                top: 100px;
                text-align: right;
                width: 160px;
            }
            .item_limit{
                color: #ffecb2;
                font-size: 14px;
                position: relative;
                background-color: rgba(0,0,0,0.3);
                padding: 2px 10px;
                float: left;
                top: 177px;
                left: 24px;
                margin-left: 10px;
            }
            .item_content{
                color:#584227;
                font-size: 20px;
                line-height: 25px;
                text-align: center;
                position: absolute;
                top: 205px;
                padding: 0 40px;
                height: 75px;
                overflow-y: scroll;
                &::-webkit-scrollbar{
                    width: 0 !important;
                    height: 0 !important;
                    display: none;
                }
            }
        }
        .half_center{
            width: 872px;
        }
        .full_center{
            width: 1272px;
        }
        .content_right{
            // background: url('../assets/buylist.png') 0 100% no-repeat;
            width:400px;
            .right_close{
                width: 24px;
                height: 67px;
                position: absolute;
                left: 1177px;
                top: 354px;
                cursor: pointer;
            }
            .clear{
                position: relative;
                right: 0;
                text-align: right;
                height: 40px;
                line-height: 40px;
                padding-right: 40px;
                cursor: pointer;
            }
            .buy_list_box{
                height: 625px;
                overflow-y: scroll;
                &::-webkit-scrollbar{
                    width: 0 !important;
                    height: 0 !important;
                    display: none;
                }
            }
            .buy_list{
                position: relative;
                height: 130px;
                border-bottom: 2px solid #473420;
                margin-left: 10px;
                .list_name{
                    font-size: 30px;
                    text-align: left;
                    text-indent: 20px;
                    font-weight: bolder;
                    line-height: 36px;
                    top: 10px;
                    position: relative;
                }
                .list_limit{
                    span{
                        color: #ffecb2;
                        font-size: 16px;
                        position: relative;
                        // display: inline-block;
                        text-align: left;
                        background-color: #2e2216;
                        padding: 2px 10px;
                        margin-left: 10px;
                        top: 10px;
                        float: left;
                    }
                }
                .list_point{
                    font-size: 18px;
                    position: relative;
                    top: 20px;
                    text-align: left;
                    text-indent: 20px;
                    line-height: 36px;
                    float: left;
                }
                .item_count{
                    top: 90px;
                }
            }

            .total_count{
                font-size: 24px;
                line-height: 36px;
                margin-top: 20px;
            }
            .submit{
                // background: url('../assets/submit.png') 0 0 no-repeat;
                width: 190px;
                height: 44px;
                font-size: 32px;
                line-height: 44px;
                color: #5d371a;
                position: relative;
                left: 105px;
                cursor: pointer;
            }
            // background-color: #fff;
        }
        .buy_car{
            // background: url('../assets/buy_car.png') 0 0 no-repeat;
            width: 187px;
            height: 177px;
            position: absolute;
            right: 10px;
            bottom: 50px;
            cursor: pointer;
            div{
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>